// 모듈C — 공정 파라미터 권고값 계산 유틸 + 기본(적용 대상) 권고 세트
// 화면1(권고 생성/승인) → 화면2(세이프가드)가 공유.
// 실제 API 연동 시 raw 배열만 백엔드 조회로 교체하면 됨.

// raw 파라미터 배열 → Δ·임계범위내 여부·상태를 계산해 반환
export const computeParams = (rawList) =>
  rawList.map((p) => {
    const delta = Math.round((p.recommended - p.current) * 10) / 10;
    const range = p.max - p.min;
    const within = p.recommended >= p.min && p.recommended <= p.max;
    const marginRatio = within
      ? Math.min(p.recommended - p.min, p.max - p.recommended) / range
      : -1;
    const status = !within ? 'exceed' : marginRatio < 0.1 ? 'warn' : 'normal';
    return { ...p, delta, within, marginRatio, status };
  });

// 기본(현재 적용 대상) 권고 세트 — 세이프가드 화면이 참조하는 정본
const canonicalRaw = [
  { key: 'injectionPressure', labelKey: 'pages.modulec.params.injectionPressure', unit: 'MPa', current: 118.0, recommended: 124.5, min: 90, max: 130, tempFactor: false },
  { key: 'injectionSpeed', labelKey: 'pages.modulec.params.injectionSpeed', unit: 'mm/s', current: 78, recommended: 85, min: 40, max: 95, tempFactor: false },
  { key: 'holdingPressure', labelKey: 'pages.modulec.params.holdingPressure', unit: 'MPa', current: 60, recommended: 66, min: 40, max: 75, tempFactor: false },
  { key: 'moldTemp', labelKey: 'pages.modulec.params.moldTemp', unit: '℃', current: 52, recommended: 58, min: 40, max: 60, tempFactor: true },
  { key: 'coolingTime', labelKey: 'pages.modulec.params.coolingTime', unit: 's', current: 18.0, recommended: 16.5, min: 12, max: 25, tempFactor: false },
];

export const recommendedParams = computeParams(canonicalRaw);

// 파라미터 상태 배지 메타
export const paramStatusMeta = {
  normal: { labelKey: 'pages.modulec.paramStatus.normal', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  warn: { labelKey: 'pages.modulec.paramStatus.warn', color: '#fbbf24', bg: 'rgba(251,191,36,0.12)' },
  exceed: { labelKey: 'pages.modulec.paramStatus.exceed', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

// 임계 초과(차단 대상) 파라미터 존재 여부 (기본 세트 기준)
export const hasExceed = recommendedParams.some((p) => p.status === 'exceed');
